<div>
  <br />
  <p class="retrofit-task-item-title">
    <span>
      Permit Receipt
    </span>
  </p>
  <div>Did homeowner pay for permit receipt?</div>


  <form [formGroup]="formPermitReceiptInfo">
    <div style="margin-top:10px;margin-bottom:10px;">
      <mat-radio-group
        id="permitHomeownerPaid"
        name="permitHomeownerPaid"
        formControlName="permitHomeownerPaid"
        (change)="onChangeEventPermitReceipt($event)"
        class="retrofit-task-radio-group horizontal-radio">
        <mat-radio-button value="yes">
          Yes
        </mat-radio-button>
        <mat-radio-button value="no">
          No
        </mat-radio-button>
      </mat-radio-group>
      @if (this.loading && !this.permitHomeownerPaid) {
        <div class="w-400">
          <br />
          Loading...
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
    @if (permitHomeownerPaid == true) {
      <div>
        <div class="retrofit-form-text">
          <div [innerHTML]="textPermitReceiptFileIntroSgHelpText"></div>
        </div>
        <br />
        <ebb-portal-file-list
          [context]="'PreRetrofit'"
          [title]=""
          [application]="applicationData"
          [task]="taskSgFiltered"
          [disable]="sgPermitReceiptSubmitted"
          (emitFileUploadEvent)="onEmitFileUploadEvent($event)"
          >
        </ebb-portal-file-list>
        @if (this.loading) {
          <div class="w-400">
            Loading...
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        <br />
        <div class="retrofit-form-text">
          <div [innerHTML]="textPermitReceiptCostIntroSgHelpText"></div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            <mat-form-field
              appearance="outline"
              style="min-width: 250px;">
              <mat-label>Permit Cost</mat-label>
              <input matInput
                (change)="setCostToZeroIfEmpty($event)" currencyMask min="0.01"
                id="permitCostPre"
                name="permitCostPre"
                placeholder="Permit Cost"
                formControlName="permitCost">
                @if (formPermitReceiptInfo.get('permitCost').hasError('min')) {
                  <mat-error>
                    Permit receipt cost must be greater than $1.00.</mat-error>
                }
                <mat-hint>
                  $1 or more
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <button
                mat-raised-button color="primary"
                type="button"
                (click)="onClickSavePermitReceiptInfo()"
                [disabled]="checkPermitReceiptFormLock()">
                SAVE & SUBMIT
              </button>
            </div>
          </div>
        </div>
      }
    </form>
  </div>